import React, {ChangeEvent, useState} from "react";
import {useRouter} from "next/navigation";
import {Input} from "../../input";
import {RadioGroup} from "@radix-ui/react-radio-group";
import {Checkbox} from "@/components/ui/checkbox";
import {Button} from "../../button";
import toast from "react-hot-toast";

const priceRanges = [
    {label: "تا 100 هزار تومان", value: "0-100000"},
    {label: "از 100 تا 500 هزار تومن", value: "100000-500000"},
    {label: "از 500 تا یک میلیون تومان", value: "500000-1000000"},
    {label: "از ۱ تا دو میلیون تومان", value: "1000000-2000000"},
    {label: "2 میلیون تومان به بالا", value: "2000000-"},
];

function PriceRangeFilter() {
    const [selectedPrice, setSelectedPrice] = useState("");
    const [minPrice, setMinPrice] = useState("");
    const [maxPrice, setMaxPrice] = useState("");

    const router = useRouter();

    const handlePriceChange = (e: any) => {
        const {value, id} = e.target;
        if (/^\d*$/.test(value)) {
            if (id === "minPrice") {
                setMinPrice(value);
                setSelectedPrice("");
            } else if (id === "maxPrice") {
                setMaxPrice(value);
                setSelectedPrice("");
            }
        } else {
            toast.error("عدد لاتین وارد کنید.", {
                position: 'top-center'
            })
        }
    };

    const handleRangeSelection = (rangeValue: any) => {
        if (selectedPrice === rangeValue) {
            setSelectedPrice("");
            setMinPrice("");
            setMaxPrice("");
        } else {
            setSelectedPrice(rangeValue);
            const [min, max] = rangeValue.split("-");
            setMinPrice(min || "0");
            setMaxPrice(max || "");
        }
    };

    const applyCustomPriceFilter = () => {
        const queryParams = new URLSearchParams(window.location.search);
        if (minPrice) queryParams.set("min_price", minPrice);
        if (maxPrice) queryParams.set("max_price", maxPrice);
        router.push(`?${queryParams.toString()}`);
    };

    return (
        <div className="mb-4 flex w-full flex-wrap">
            <RadioGroup value={selectedPrice} className="space-y-2 mb-4 w-full">
                {priceRanges.map((range, index) => (
                    <div key={index} className="flex flex-wrap justify-end items-center w-full">
                        <label
                            htmlFor={`price-${index}`}
                            className="ml-2 text-gray-500 w-full flex items-center justify-end gap-2"
                        >
                            {range.label}
                            <Checkbox
                                id={`price-${index}`}
                                value={range.value}
                                checked={selectedPrice === range.value}
                                onCheckedChange={() => handleRangeSelection(range.value)}
                            />
                        </label>
                    </div>
                ))}
            </RadioGroup>
            <div className="flex items-center justify-between mb-2">
                <Input
                    id="minPrice"
                    placeholder="حداقل"
                    value={minPrice}
                    onChange={handlePriceChange}
                    className="w-[47%] text-center rounded-xl h-[44px]"
                />
                <Input
                    id="maxPrice"
                    placeholder="حداکثر"
                    value={maxPrice}
                    onChange={handlePriceChange}
                    className="w-[47%] rounded-xl text-center h-[44px]"
                />
            </div>
            <Button
                variant="outline"
                className="w-full text-gray-500 border border-gray-200 rounded-xl flex items-center text justify-center h-[44px]"
                onClick={applyCustomPriceFilter}
            >
                اعمال قیمت
            </Button>
        </div>
    );
}

export default PriceRangeFilter;